export default __webpack_public_path__ + "static/media/banner-acidentes-pessoais-bem-estar.aeab7314.png";